module.exports = __webpack_public_path__ + "img/cabify-logo.a2c83c68.png";